<div class="font-bold mb-3" i18n>Routing Indicator, alongside MCC and MNC, routes network signaling with SUCI to AUSF and UDM.</div>
<div class="font-bold mb-3" i18n>
  Please provide a Routing Indicator (a number between 0 and 9999). '0' will get inserted if no other value is provided. '0' means that
  HPLMN intends not to configure a valid Routing Indicator in the USIM.
</div>
<div class="ml-6">
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="mt-5" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>Routing Indicator</span>
      </td>
      <td>
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          rsNumbersOnlyInput
          maxlength="4"
          (input)="handleFormEvents()"
          placeholder="0"
          [(ngModel)]="profileValues.suciEncryptionScheme.routingIndicator"
        />
      </td>
    </tr>
  </table>
</div>
